import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApartadosComponent } from './apartados.component';

import { jqxTreeModule } from 'jqwidgets-ng/jqxtree';
import { jqxButtonModule } from 'jqwidgets-ng/jqxbuttons';
import { jqxDropDownListModule } from 'jqwidgets-ng/jqxdropdownlist';
import { jqxLoaderModule } from 'jqwidgets-ng/jqxloader';
import { jqxInputModule } from 'jqwidgets-ng/jqxinput';
import { FormsModule } from '@angular/forms';
import { jqxGridModule } from 'jqwidgets-ng/jqxgrid';

@NgModule({
  declarations: [ApartadosComponent],
  imports: [
    CommonModule,
    FormsModule,
    jqxLoaderModule,
    jqxTreeModule,
    jqxButtonModule,
    jqxDropDownListModule,
    jqxInputModule,
    jqxGridModule,
  ],
  exports: [ApartadosComponent],
})
export class ApartadosModule {}
